export default {
    appTitle: 'Web de proveedores',
    backLabel: 'Regresar',
    title: 'Verificación de dos pasos activada',
    body:{
      message:'Se ha enviado un mensaje de verificación a la dirección de correo <strong>{email}</strong> para confirmar el inicio de sesión de forma segura. <br><br> Busca dentro del mensaje el enlace <strong>Ingresar a mi cuenta</strong> para continuar.',
      buttonResend:'Volver a enviar',
      buttonResendTimer:'Reintente en {timer} mins.',
      disclaimer:'Este proceso puede demorar algunos minutos. <br>En caso de no recibirlo, por favor verifica tu bandeja de spam o intenta de nuevo'
    },
    errors:{
      invalidLink:'Este enlace ya no se encuentra disponible'
    },
    ResendLinkMessages:{
      success:'Se ha reenviado el mensaje de verificación exitosamente.',
      error:'No se ha podido reenviar el mensaje de verificación.'
    },

    SmsVerification:{
      title:'Ingresa el código de verificación:',
      sendTo:'Enviado a:',
      resendTime:'Reenviar código en {timer}.',
      buttonResend:'Reenviar código',
      verifyButton:'Verificar OTP',
      backToLogin:'Volver al login',
      success:'Código de verificación correcto',
      errors:{
        codeFail:'Código de verficación incorrecto ¡vuelve a intertarlo!.',
        manyAttempts:'Haz alcanzado el límite de reintentos. Espera {timer} para volver a intentarlo.',
      },
    }
  }
  